import { render } from "./ExitConfirmation.vue?vue&type=template&id=8e0cdeee"
import script from "./ExitConfirmation.vue?vue&type=script&lang=js"
export * from "./ExitConfirmation.vue?vue&type=script&lang=js"

import "./ExitConfirmation.vue?vue&type=style&index=0&id=8e0cdeee&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__